import { FiGift } from "react-icons/fi";
import React from "react";
import "./OwnWelcomeModal.css";

/**
 * Post-onboarding welcome for users who signed up via the OWN partner link.
 * The bonus unlocks on their FIRST PAID PLAN (no credits at signup), so this
 * teases the offer and points them to plans.
 */
export default function OwnWelcomeModal({ isOpen, credits = 150, onClose, onCta }) {
  if (!isOpen) return null;
  return (
    <div className="own-welcome-overlay" onClick={onClose}>
      <div className="own-welcome-card" onClick={(e) => e.stopPropagation()}>
        <button className="own-welcome-close" onClick={onClose} aria-label="Close">
          ×
        </button>

        <div className="own-welcome-badge">OWN × CLIPBAIT</div>

        <div className="own-welcome-gift"><FiGift /></div>

        <h2 className="own-welcome-title">
          {credits} bonus credits, on us
        </h2>
        <p className="own-welcome-sub">
          Welcome from <strong>OWN</strong>. Go Pro and we'll drop{" "}
          <strong>{credits} bonus credits that never expire</strong> straight
          into your account. That's your first stream, on the house.
        </p>

        <button className="own-welcome-cta" onClick={onCta || onClose}>
          Go Pro &amp; claim 150 credits
        </button>
      </div>
    </div>
  );
}
